import {
  ADD_CLINIC_TRANSFER_EMBRYOS,
  Day7FrozenEmbryo,
  Fertilization,
  GET_CSR_DAY_7,
  GET_DAY_7_FROZEN_EMBRYOS,
  GET_PSE_DAY_7,
  GET_PSE_DAY_7_MATINGS,
  TOG_CsrDay7,
  TOG_PseDay7,
  UPDATE_FRESH_TRANSFERS,
  UPDATE_FRESH_TRANSFERS_PSE,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

interface CsrDay7Response {
  csrDay7: TOG_CsrDay7[];
}
interface PseDay7Response {
  pseDay7: TOG_PseDay7[];
}
interface PseDay7MatingsResponse {
  pseDay7Matings: Fertilization[];
}

interface GetDay7FrozenEmbryosResponse {
  day7FrozenEmbryos: Day7FrozenEmbryo[];
}

export const excelApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getCsrDay7: build.query({
      query: (variables) => ({
        document: GET_CSR_DAY_7,
        variables,
      }),
      transformResponse: (response: CsrDay7Response) => response.csrDay7,
      providesTags: ['CsrDay7'],
    }),
    getPseDay7: build.query({
      query: (variables) => ({
        document: GET_PSE_DAY_7,
        variables,
      }),
      transformResponse: (response: PseDay7Response) => response.pseDay7,
      providesTags: ['PseDay7'],
    }),
    getPseDay7Matings: build.query({
      query: (variables) => ({
        document: GET_PSE_DAY_7_MATINGS,
        variables,
      }),
      transformResponse: (response: PseDay7MatingsResponse) =>
        response.pseDay7Matings,
      providesTags: ['PseDay7Matings'],
    }),
    getDay7FrozenEmbryos: build.query({
      query: (variables) => ({
        document: GET_DAY_7_FROZEN_EMBRYOS,
        variables,
      }),
      transformResponse: (response: GetDay7FrozenEmbryosResponse) =>
        response.day7FrozenEmbryos,
      providesTags: ['Day7FrozenEmbryos'],
    }),
    updateFreshTransfers: build.mutation({
      query: (variables) => ({
        document: UPDATE_FRESH_TRANSFERS,
        variables,
      }),
    }),

    addClinicTransferEmbryos: build.mutation({
      query: (variables) => ({
        document: ADD_CLINIC_TRANSFER_EMBRYOS,
        variables,
      }),
      invalidatesTags: ['PseDay7', 'PseDay7Matings'],
    }),
    updateFreshTransfersPSE: build.mutation({
      query: (variables) => ({
        document: UPDATE_FRESH_TRANSFERS_PSE,
        variables,
      }),
      invalidatesTags: ['PseDay7'],
    }),
  }),
});

export const {
  useGetCsrDay7Query,
  useGetPseDay7Query,
  useLazyGetPseDay7Query,
  useGetPseDay7MatingsQuery,
  useUpdateFreshTransfersMutation,
  useAddClinicTransferEmbryosMutation,
  useGetDay7FrozenEmbryosQuery,
  useUpdateFreshTransfersPSEMutation,
} = excelApi;
